/*
 * @Author: changcheng
 * @LastEditTime: 2024-08-28 09:16:43
 */
import "./index.scss"
import improveCourse1 from '@root/img/improveCourse1.jpg';
import improveCourse2 from '@root/img/improveCourse2.jpg';
import improveCourse3 from '@root/img/improveCourse3.jpg';
import improveCourse4 from '@root/img/improveCourse4.jpg';
import improveCourse5 from '@root/img/improveCourse5.jpg';
import improveEnterCourse from "@root/img/improveEnterCourse.png";
import tyyOutBtn from "@root/img/tryOutBtn.jpg";
// 课程地址
const courseUrlList  = [
    "https://p.bokecc.com/qrplay.bo?uid=CCF632C922256BB9&vid=7650BF2851FE2118753C612EB38A8D5A",
    "https://p.bokecc.com/qrplay.bo?uid=CCF632C922256BB9&vid=7650BF2851FE2118F3342D97BB1D6DF8",
    "https://p.bokecc.com/qrplay.bo?uid=D71B0368E20B4CF5&vid=ECB4BD26A630977A13358DE27D943A99",
    "https://p.bokecc.com/qrplay.bo?uid=D71B0368E20B4CF5&vid=D9E2BE26B9BDA27D2BBA984E86119800",
]
export default  function CompreImprovement() {
    /**
     * 课程播放
     */
    const coursePlay = (index:number)=>{
      window.open(courseUrlList[index])
    }
    const tryOutCourse = ()=>{
        window.open("https://school.mvwchina.com/projectPage/#/?projectId=2098")
    }
    return <div style={{
        textAlign:"center"
    }}> 
        <img src={improveCourse1} alt=""/>
        <img src={improveCourse2} alt=""/>
        <img src={improveCourse3} alt=""/>
        <img src={improveCourse4} alt=""/>
        <div className="improve_courseList">
            <img src={improveCourse5} alt=""/>
            <div className="course_list1" onClick={()=>{
                coursePlay(0)
            }}>
                <a>公立医院高质量发展的思考 </a>
                <img src={improveEnterCourse} alt=""/>
            </div>
            <div className="course_list2" onClick={()=>{
                coursePlay(1)
            }}>
                <a>推进基层医疗高质量发展的践与行</a>
                <img src={improveEnterCourse} alt=""/>
            </div>
            <div className="course_list3" onClick={()=>{
                coursePlay(2)
            }}>
                <a>危重患者的医患沟通(上)</a>
                <img src={improveEnterCourse} alt=""/>
            </div>
            <div className="course_list4" onClick={()=>{
                coursePlay(3)
            }}>
                <a>危重患者的医患沟通(下)</a>
                <img src={improveEnterCourse} alt=""/>
            </div>
            <img src={tyyOutBtn} alt="" className="tryOut" onClick={()=>{
                tryOutCourse()
            }}/>
        </div>
       
    </div>
}